import { Component, computed, inject, OnInit, Signal } from '@angular/core';

import { ProfileInfoBoxComponent } from '../../profile-info-box.component';
import { ProfileInfoBoxBaseComponent } from '../profile-info-box-base.component';
import { FormRowComponent } from '../../../../form/form-row/form-row.component';
import { FormFieldComponent } from '../../../../form/form-field/form-field.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IMDDropDownOption, MDDropDownComponent } from '@melodic-ui/components';
import { TimezoneStateService } from '@lb/state/timezone-state.service';

@Component({
	selector: 'lb-profile-location-info-box',
	standalone: true,
	imports: [FormsModule, ReactiveFormsModule, ProfileInfoBoxComponent, FormRowComponent, FormFieldComponent, MDDropDownComponent],
	templateUrl: './profile-location-info-box.component.html',
	styleUrl: './profile-location-info-box.component.scss'
})
export class ProfileLocationInfoBoxComponent extends ProfileInfoBoxBaseComponent implements OnInit {
	private readonly timezoneStateService = inject(TimezoneStateService);

	public timeZoneOptions: Signal<IMDDropDownOption[]> = computed(() => {
		return this.timezoneStateService.timezones().map((timezones) => {
			return {
				value: timezones.timeZoneID,
				label: timezones.timeZoneName,
				selected: this.profile().timeZone?.timeZoneID === timezones.timeZoneID
			};
		});
	});
	ngOnInit(): void {
		const form: FormGroup = this.form();
		const isDisabled = this.formDisabled() || false;

		form.addControl('streetAddress', new FormControl({ value: this.profile().streetAddress, disabled: isDisabled }, { validators: [Validators.required] }));
		form.addControl('streetAddress2', new FormControl({ value: this.profile().streetAddress2, disabled: isDisabled }));
		form.addControl('city', new FormControl({ value: this.profile().city, disabled: isDisabled }, { validators: [Validators.required] }));
		form.addControl('state', new FormControl({ value: this.profile().state, disabled: isDisabled }, { validators: [Validators.required] }));
		form.addControl('postalCode', new FormControl({ value: this.profile().postalCode, disabled: isDisabled }, { validators: [Validators.required] }));
		form.addControl('country', new FormControl({ value: this.profile().country, disabled: isDisabled }));
		form.addControl('timezone', new FormControl({ value: this.profile().timeZone?.timeZoneID, disabled: true }));
	}
}
